// Pure helpers for the clinic Orders & Followups UI.
export const ORDER_STATUSES = ["unassigned", "pending", "completed"];

const STATUS_COLOR = {
  unassigned: "gray",
  pending: "purple",
  completed: "green",
};

export function statusColor(status) {
  return STATUS_COLOR[status] || "gray";
}

export function statusLabel(status) {
  const s = String(status || "");
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : "";
}

export const itemTypeLabel = (t) => (t === "followup" ? "Followup" : "Order");
